document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.search-input');
  const items = document.querySelectorAll('.search-content-text');
  const pagination = document.querySelector('.pagination');

  if (!searchInput) return;

  searchInput.addEventListener('input', () => {
    const term = searchInput.value.toLowerCase().trim();
    let hasResults = false;

    items.forEach((item) => {
      const match = item.textContent.toLowerCase().includes(term);
      item.style.display = match ? '' : 'none';
      if (match) hasResults = true;
    });

    if (pagination) {
      pagination.style.display = hasResults ? '' : 'none';
    }
  });
});
